import { TrashIcon } from '@phosphor-icons/react';
import React from 'react';
import toast from 'react-hot-toast';

import { captureException } from '@sentry/react';
import { ConfirmDialog } from '../../../../components/dialog/ConfirmDialog';
import { deleteOrderComplaint } from '../../models';
import { getDisplayError } from '../../../../utils/get-display-error';
import { useOrder } from './orderContext';

export interface IDeleteOrderComplaintDialogProps {
  complaintId: string;
  onDeleted?: () => void;
}

export const DeleteOrderComplaintDialog: React.FC<IDeleteOrderComplaintDialogProps> = ({ complaintId, onDeleted }) => {
  const { refreshData } = useOrder();

  const handleDelete = async () => {
    try {
      await deleteOrderComplaint(complaintId);

      toast.success('Klacht verwijderd');
      await refreshData();
      if (onDeleted) {
        onDeleted();
      }
    } catch (err) {
      captureException(err);
      console.error('Failed to delete complaint', err);
      toast.error('Kon klacht niet verwijderen: ' + getDisplayError(err));
    }
  };

  return (
    <ConfirmDialog
      triggerColor="danger-outline"
      triggerText={<TrashIcon className="w-4 h-4" weight="regular" />}
      title="Klacht verwijderen"
      submitText="Verwijderen"
      description="Weet je zeker dat je deze klacht wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt en alle bijlagen worden ook verwijderd."
      onSubmit={handleDelete}
    />
  );
};
